import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import UseGPIPayFields from './UseGPIPayFields';
import GPICreditCardFields from './GPICreditCardFields';
import CreditCardFeeDisclaimer from '../CreditCardFeeDisclaimer';

import '../SubscriptionPaymentOptions.scss';
import NoticeBlock from '../../../Common/NoticeBlock';

const GPICreditCardForm = ({ cognitoSub, getCreditCards, isViewOnly, showCreditCardForm, saveCardInfo, creditCardFeeDetails = {} }) => {
  const [GPIError, setGPIError] = useState('');
  const [success, setSuccess] = useState(false);
  const [street, setStreet] = useState();
  const [zip, setZip] = useState();

  useEffect(() => {
    setTimeout(() => {
      setGPIError('');
    }, 3000);
  }, [GPIError])

  const onSuccess = (token) => {
    setSuccess(true);

    setStreet('');
    setZip('');
    getCreditCards(token);
    setGPIError('');

    setTimeout(() => {
      setSuccess(false);
    }, 3000);
  }

  const {
    creditCardFeePrice = '',
    creditCardFeeQueryInProgress = false,
    creditCardFeeQueryError = false,
  } = creditCardFeeDetails;

  return (
    <Grid container spacing={3}>
      <>
        <UseGPIPayFields
          setSuccess={setSuccess}
          setGPIError={setGPIError}
          onSuccess={onSuccess}
          street={street}
          zip={zip}
          cognitoSub={cognitoSub}
          isViewOnly={isViewOnly}
          showCreditCardForm={showCreditCardForm}
          saveCardInfo={saveCardInfo}
        />
        <GPICreditCardFields />
        <Grid item xs={12} sm={4}>
          <TextField
            className='address-input'
            label='Street Address'
            name='gpi-address'
            variant='outlined'
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={street}
            onChange={(event) => setStreet(event.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            className='address-input'
            label='Zip Code'
            name='gpi-zip'
            variant='outlined'
            required
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={zip}
            onChange={(event) => setZip(event.target.value)}
          />
        </Grid>
      </>
      <Grid item xs={12}>
        <div className='parkchirp--payment-action-button'>
          <CreditCardFeeDisclaimer
            creditCardFeePrice={creditCardFeePrice}
            creditCardFeeQueryInProgress={creditCardFeeQueryInProgress}
            creditCardFeeQueryError={creditCardFeeQueryError}
          />
          <div id='submit-gpi'></div>
          {GPIError && (
            <div className='parkchirp--payment-success-text'>
              <NoticeBlock
                type='error'
                containerClasses={['parkchirp--sidebar-block']}
              >
                <p>{GPIError}</p>
              </NoticeBlock>
            </div>
          )}
          {(success && !showCreditCardForm) && (
            <div className='parkchirp--payment-success-text'>
              <NoticeBlock
                type='message'
                containerClasses={['parkchirp--sidebar-block']}
              >
                <p>Card added to your account.</p>
              </NoticeBlock>
            </div>
          )}
        </div>

      </Grid>
    </Grid>
  );
};

export default GPICreditCardForm;
